const CommonSidebar = () => import(/* webpackChunkName: "component.header" */ '@/components/Sidebar');
const CommonHeader = () => import(/* webpackChunkName: "component.header" */ '@/components/Header');
const CommonFooter = () => import(/* webpackChunkName: "component.header" */ '@/components/Footer');

export default {
  path: 'codes',
  components: {
    sidebar: CommonSidebar,
    header: CommonHeader,
    footer: CommonFooter,
    default: () => import(/* webpackChunkName: "module.codes" */ '@/views/Codes'),
  },
  meta: {
    breadcrumb: {
      label: 'Codes',
    },
  },
  children: [
    {
      path: '',
      name: 'codes-listing',
      component: () => import(/* webpackChunkName: "module.codes.list" */ '@/modules/Codes/List'),
      meta: {
        breadcrumb: {
          label: 'Codes',
        },
      },
    },
    {
      path: ':id/edit',
      name: 'codes-edit',
      component: () => import(/* webpackChunkName: "module.codes.edition" */ '@/modules/Codes/Edition'),
      meta: {
        breadcrumb: {
          parent: 'codes-listing',
          label: 'Edit Code',
        },
      },
    },
    {
      path: 'create',
      name: 'codes-create',
      component: () => import(/* webpackChunkName: "module.codes.edition" */ '@/modules/Codes/Edition'),
      meta: {
        breadcrumb: {
          parent: 'codes-listing',
          label: 'Create Code',
        },
      },
    },
    {
      path: 'create-bulk',
      name: 'codes-create-bulk',
      component: () => import(/* webpackChunkName: "module.codes.bulk" */ '@/modules/Codes/Bulk'),
      meta: {
        breadcrumb: {
          parent: 'codes-listing',
          label: 'Create Bulk Code',
        },
      },
    },
  ],
};
